import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import DemoUnauthorizedModal from '../components/shared/DemoUnauthorizedModal';
import { useAuth } from './AuthContext';

const DemoGuardContext = createContext(null);

export const DEMO_BLOCKED_EVENT = 'fmps:demo-blocked';

export function DemoGuardProvider({ children }) {
  const { user } = useAuth();
  const isDemo = user?.role === 'FMPS-DEMO';
  const [open, setOpen] = useState(false);

  const showDemoBlocked = useCallback(() => {
    setOpen(true);
  }, []);

  const blockIfDemo = useCallback(
    (fn) => (...args) => {
      if (isDemo) {
        setOpen(true);
        return undefined;
      }
      return fn?.(...args);
    },
    [isDemo],
  );

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(DEMO_BLOCKED_EVENT, handler);
    return () => window.removeEventListener(DEMO_BLOCKED_EVENT, handler);
  }, []);

  return (
    <DemoGuardContext.Provider value={{ isDemo, showDemoBlocked, blockIfDemo }}>
      {children}
      <DemoUnauthorizedModal isOpen={open} onClose={() => setOpen(false)} />
    </DemoGuardContext.Provider>
  );
}

export function useDemoGuard() {
  const ctx = useContext(DemoGuardContext);
  if (!ctx) {
    return { isDemo: false, showDemoBlocked: () => {}, blockIfDemo: (fn) => fn };
  }
  return ctx;
}

export default DemoGuardContext;
